import { useState, useCallback } from 'react';
import Button from '../Button';
import NavLink from '../NavLink';
import { Row, DesktopNav, Hamburguer, MobileNav, BackgroundExit, LogoTitle } from './style';
import { NAVIGATION_LINKS, CONTACTS, COMPANY_NAME } from '../../constants';
import logo2 from '../../assets/images/logo2.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <header role="banner">
      <Row>
        <LogoTitle>
          <img src={logo2} alt={`Logo ${COMPANY_NAME}`} width="40" height="40" />
          <h1>{COMPANY_NAME}</h1>
        </LogoTitle>
        <DesktopNav role="navigation" aria-label="Menu principal">
          <ul>
            {NAVIGATION_LINKS.map((link) => (
              <NavLink key={link.id} href={`#${link.id}`} label={link.label} />
            ))}
          </ul>
          <Button color="wpp" href={CONTACTS.WHATSAPP.url} target="_blank" rel="noopener noreferrer" aria-label="Fale conosco pelo WhatsApp">
            Fale conosco
          </Button>
        </DesktopNav>
        <Hamburguer 
          onClick={toggleMenu} 
          aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        />
      </Row>
      <MobileNav 
        $open={menuOpen} 
        id="mobile-menu"
        role="navigation" 
        aria-label="Menu mobile"
        aria-hidden={!menuOpen}
      >
        <ul>
          {NAVIGATION_LINKS.map((link) => (
            <NavLink key={link.id} href={`#${link.id}`} label={link.label} onClick={closeMenu} />
          ))}
        </ul>
        <Button color="wpp" href={CONTACTS.WHATSAPP.url} target="_blank" rel="noopener noreferrer" aria-label="Fale conosco pelo WhatsApp">
          Fale conosco
        </Button>
      </MobileNav>
      <BackgroundExit $open={menuOpen} onClick={closeMenu} aria-hidden="true" />
    </header>
  );
};

export default Header;